{
  "version": 1,
  "source": "docs/reference/painting-1538-amsterdam-museum.jpg",
  "sourceSize": [
    6692,
    4866
  ],
  "notes": "14 approximate visible gable picks, 14 hidden Warmoes fronts, and eleven Lange Niezel fronts retained from the woodcut count. Every level, chainage, width and hidden depth is estimated; not recovered cadastral plots. See docs/oudezijde-blocks.md.",
  "rows": [
    {
      "id": "lange-niezel-south",
      "source": "street-lange-niezel",
      "side": "left",
      "from": 13.5,
      "to": 81.5,
      "depth": 16,
      "evidence": "inferred",
      "note": "Retains the prior 1544 woodcut count of eleven fronts and zero stepped gables. Individual widths, heights and hidden depths remain inferred.",
      "houses": [
        {
          "id": "lange-niezel-south-01",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "lange-niezel-south-02",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "lange-niezel-south-03",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "lange-niezel-south-04",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "lange-niezel-south-05",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "lange-niezel-south-06",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "lange-niezel-south-07",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "lange-niezel-south-08",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "lange-niezel-south-09",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "lange-niezel-south-10",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        },
        {
          "id": "lange-niezel-south-11",
          "widthWeight": 1,
          "storeys": 2,
          "roof": "tile",
          "gable": "plain"
        }
      ]
    },
    {
      "id": "oudekerk-canal-niezel",
      "source": "quay-oudezijds-voorburgwal-2",
      "side": "left",
      "from": 509,
      "to": 547,
      "depth": 32,
      "opposite": "street-warmoesstraat",
      "evidence": "painted",
      "houses": [
        {
          "id": "oudekerk-canal-niezel-01",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "slate",
          "paintedPixel": [
            2902,
            2978
          ]
        },
        {
          "id": "oudekerk-canal-niezel-02",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile",
          "paintedPixel": [
            2929,
            3018
          ]
        },
        {
          "id": "oudekerk-canal-niezel-03",
          "widthWeight": 1.05,
          "storeys": 3,
          "roof": "tile",
          "paintedPixel": [
            2952,
            3043
          ]
        },
        {
          "id": "oudekerk-canal-niezel-04",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [
            2979,
            3077
          ]
        },
        {
          "id": "oudekerk-canal-niezel-05",
          "widthWeight": 1.1,
          "storeys": 3,
          "roof": "tile",
          "paintedPixel": [
            2997,
            3101
          ]
        },
        {
          "id": "oudekerk-canal-niezel-06",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "slate",
          "paintedPixel": [
            3027,
            3127
          ]
        },
        {
          "id": "oudekerk-canal-niezel-07",
          "widthWeight": 0.95,
          "storeys": 3,
          "roof": "tile",
          "paintedPixel": [
            3047,
            3157
          ]
        },
        {
          "id": "oudekerk-canal-niezel-08",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "slate",
          "paintedPixel": [
            3070,
            3190
          ]
        }
      ]
    },
    {
      "id": "niezel-canal-heintje",
      "source": "quay-oudezijds-voorburgwal-2",
      "side": "left",
      "from": 553,
      "to": 583,
      "depth": 32,
      "opposite": "street-warmoesstraat",
      "evidence": "painted",
      "houses": [
        {
          "id": "niezel-canal-heintje-01",
          "widthWeight": 1.15,
          "storeys": 3,
          "roof": "tile",
          "paintedPixel": [
            3084,
            3223
          ]
        },
        {
          "id": "niezel-canal-heintje-02",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile",
          "paintedPixel": [
            3097,
            3248
          ]
        },
        {
          "id": "niezel-canal-heintje-03",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "tile",
          "paintedPixel": [
            3115,
            3276
          ]
        },
        {
          "id": "niezel-canal-heintje-04",
          "widthWeight": 1.1,
          "storeys": 3,
          "roof": "slate",
          "paintedPixel": [
            3136,
            3304
          ]
        },
        {
          "id": "niezel-canal-heintje-05",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile",
          "paintedPixel": [
            3153,
            3332
          ]
        },
        {
          "id": "niezel-canal-heintje-06",
          "widthWeight": 0.95,
          "storeys": 3,
          "roof": "tile",
          "paintedPixel": [
            3172,
            3360
          ]
        }
      ]
    },
    {
      "id": "oudekerk-warmoes-niezel",
      "source": "street-warmoesstraat",
      "side": "right",
      "from": 296,
      "to": 350,
      "depth": 32,
      "opposite": "quay-oudezijds-voorburgwal-2",
      "evidence": "inferred",
      "houses": [
        {
          "id": "oudekerk-warmoes-niezel-01",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "oudekerk-warmoes-niezel-02",
          "widthWeight": 1.1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "oudekerk-warmoes-niezel-03",
          "widthWeight": 0.9,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "oudekerk-warmoes-niezel-04",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "oudekerk-warmoes-niezel-05",
          "widthWeight": 1.05,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "oudekerk-warmoes-niezel-06",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "oudekerk-warmoes-niezel-07",
          "widthWeight": 0.95,
          "storeys": 2,
          "roof": "slate"
        },
        {
          "id": "oudekerk-warmoes-niezel-08",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "oudekerk-warmoes-niezel-09",
          "widthWeight": 1.1,
          "storeys": 3,
          "roof": "tile"
        }
      ]
    },
    {
      "id": "niezel-warmoes-heintje",
      "source": "street-warmoesstraat",
      "side": "right",
      "from": 358,
      "to": 384,
      "depth": 30,
      "opposite": "quay-oudezijds-voorburgwal-2",
      "evidence": "inferred",
      "houses": [
        {
          "id": "niezel-warmoes-heintje-01",
          "widthWeight": 1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "niezel-warmoes-heintje-02",
          "widthWeight": 1.05,
          "storeys": 3,
          "roof": "slate"
        },
        {
          "id": "niezel-warmoes-heintje-03",
          "widthWeight": 0.95,
          "storeys": 2,
          "roof": "tile"
        },
        {
          "id": "niezel-warmoes-heintje-04",
          "widthWeight": 1.1,
          "storeys": 3,
          "roof": "tile"
        },
        {
          "id": "niezel-warmoes-heintje-05",
          "widthWeight": 0.9,
          "storeys": 3,
          "roof": "tile"
        }
      ]
    }
  ]
}
